import type { RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import Home from "../pages/home/page";
import DemoPlatform from "../pages/demo-platformu/page";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "/demo-platformu",
    element: <DemoPlatform />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;